import { ConnectButton } from '@rainbow-me/rainbowkit'



import React from 'react'
import Web3 from 'web3'
import dd from './imgs/in.jpg'
import {
	useAccount,
	useChainId,
  usePrepareTransactionRequest,
  useSendTransaction,
  useWaitForTransactionReceipt,
} from 'wagmi'

import { parseEther } from 'viem'
import { config } from './config'

import pendingGif from './imgs/pending2.gif'


import x from './imgs/icon--twitter.png'

import closeImg from './imgs/close.png'



const getTransactionReceipt = (hash, callback= ()=>{}) => {
    console.log(hash)
    window.ethereum.request({
      method: "eth_getTransactionReceipt",
      params: [hash]
    }).then((res)=>{
      if (res == null) {
        getTransactionReceipt(hash, callback)
      }
      callback(res)
    }).catch((err)=>{
      console.log(err)
    })
  }

const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.soniclabs.com'));



export function Web3App (props) {
	const [cost, setCost] = React.useState(100)  
	const [pending, setIsPending] = React.useState(false)
	const [pendingText, setPendingText] = React.useState("Transaction is in process") 
	const { address, isConnected } = useAccount()
	const chainId  = useChainId()

	const [networkConfig, setNetworkConfig] = React.useState(config["mainnet"])

	

	const sendRequest = (contract, data, callback = ()=>{}, payable = 0, gasAmount=0) => {
		setIsPending(true)
	

		if (typeof window.ethereum !== 'object') { 
		
		} else {
		

		window.ethereum.request({
			method: "eth_sendTransaction",
			params: [
			  {
			    from: address,
			    to: contract,
			    value: payable,
			    data: data,
			  },
			],}).then((hash)=>{
			  getTransactionReceipt(hash,(receipt)=>{
			    if (receipt != null) {
			      setIsPending(false)
			      callback()
			    }
			  })
			}).catch((err)=>{
			  setIsPending(false)
			})	
		}
		
	}

	const estimateGas = (contract, data, callback = ()=>{}) => {



	if (typeof window.ethereum !== 'object') {
		alert("Please open this page in the Metamask browser")
	
	} else {

		window.ethereum.request(
	        {
	          method: "eth_estimateGas",
	          params: [
	            {
	              from: address,
	              to: contract,     
	              value: web3.utils.toHex(0),
	              data: data,
	            },
	          ],
	        }
	      ).then((gasAmount)=>{
	      	console.log(gasAmount)
	        callback(gasAmount)
	      }).catch((err)=>{
	        alert(err.data.message)
	      })
	      
		}
   
}
	
	const BPT = new web3.eth.Contract(
		networkConfig["mmfa"]["bpt-abi"], 
		networkConfig["mmfa"]["bpt-address"])
	const MMFA = new web3.eth.Contract(
		networkConfig["mmfa"]["abi"], 
		networkConfig["mmfa"]["address"])
	
	React.useEffect(()=>{


	},[networkConfig])
  



  React.useEffect(
  	() => {
  		if (isConnected && !pending) {

  		} else {
  			if (pending) {
  		
  			} else {
  				if (isConnected) {
  				
  				} else {
  		
  				}
  				
  			}
  		}
  	},
  	[pending, isConnected]
  	)

  const [balBpt, setBalBpt] = React.useState(0)
  const [balMmfa, setBalMmfa] = React.useState(0)
  const getBals = () => {
  	BPT.methods.balanceOf(address)
  		.call({from: address})
  		.then((balance)=>{
  			console.log(balance)
  			setBalBpt(balance)
  			MMFA.methods.balanceOf(address)
  				.call({from: address})
  				.then((balanceM)=>{
  					setBalMmfa(balanceM)
  				})
  		})
  }





const [ready, setReady] = React.useState(false)
  const approve = () => {
  	if (Number(web3.utils.fromWei(balBpt,"ether")) > 0) {
  		BPT.methods.allowance(address, networkConfig["mmfa"]["address"])
  			.call({from: address})
  			.then((alw)=>{
  				if (Number(web3.utils.fromWei(alw,"ether")) >= Number(web3.utils.fromWei(balBpt,"ether"))) {
  					alert("you have sufficient approval")
  					setReady(true)
  				} 
  				else {
  					let data = BPT.methods.approve(networkConfig["mmfa"]["address"],balBpt).encodeABI()

  					sendRequest(
  						networkConfig["mmfa"]["bpt-address"],
  						data,
  						() => {
  							setReady(true)
  						}
  					)
  				}
  			})
  	} 
  	else {
  		alert("Refresh BPT balance or create BPT on Beets.fi")
  	}
  }

  const wrap = () => {
  	if (ready) {
  		let data = MMFA.methods.wrapTokens(balBpt).encodeABI()

  		sendRequest(
  			networkConfig["mmfa"]["address"],
  			data,
  			()=>{
  				setReady(false)
  				getBals()
  			}
  			)

  	}
  	else {
  		alert("Complete Approval process")
  	}
  }

  const unwrap = () => {
  	if (Number(web3.utils.fromWei(balMmfa,"ether")) > 0) {
  		alert("you are unwrapping all of your MMFA")
  		let data = MMFA.methods.unWrapTokens(balMmfa).encodeABI()
  		sendRequest(
  			networkConfig["mmfa"]["address"],
  			data,
  			()=>{
  				getBals()
  			}
  			)
  	} else {
  		alert("No MMFA to Unwrap")
  	}
  }


 

  return (
  	<div className={"App App--" + isConnected + " App-chain--" + chainId}>
	  	<div className="bg">
	  		<div className="inner">
	  			<div className="inner-inner">
		  		<h1>Are you IN?</h1>
		  		<p>IN is an experiment. The goal of this experiment is to run a decentralized ecosystem of Index Funds on Sonic Labs.</p>
		  		<p>Any community member is encouraged to participate in this effort.</p>
		  		<p>To celebrate the Launch of Meme Mania, we have created a <a href="https://beets.fi/pools/sonic/v2/0x1f0b203409233345a9d3c87a0310db58e5198bb80001000000000000000000a2" target="_blank">Meme Mania fund on Beets.fi</a></p>
		  		<p>1000 BPT tokens = 1 <strong>$MMFA</strong></p>
		  		<h2>Step 1: Add Liquidity</h2>
		  		<p>To help bootstrap this concept, head over to <a href="https://beets.fi/pools/sonic/v2/0x1f0b203409233345a9d3c87a0310db58e5198bb80001000000000000000000a2" target="_blank">Meme Mania Fund A on Beets.fi</a> and add liquidity.</p>
		  		<p>Don't add too much at once before the liquidity has deepened!</p>
		  		<p><button onClick={getBals}>Check</button> your balance before continuing.</p>
		  		<div className="balances">
		       		<div>{web3.utils.fromWei(balBpt,"ether")} BPT</div>
		       		<div>{web3.utils.fromWei(balMmfa,"ether")} MMFA</div>
		       	</div>
		  		<h2>Step 2: Approve Your BPT Tokens</h2>
		  		<p>Please review the <a href="https://sonicscan.org/token/0x7acea008bdfe4fe24edc186c7b82d71f70d27d9a#code" target="_blank">MMFA contract</a> before you approve.</p>
		  		<p><button onClick={approve}>Approve</button> your BPT tokens. This will approve your full balance.</p>
		  		<h2>Step 3: Wrap your BPT Tokens</h2>
		  		<p><button onClick={wrap}>Wrap</button> your BPT tokens for <strong>$MMFA</strong>.</p>
		  		<h2>Unwrap your MMFA</h2>
		  		<p><button onClick={unwrap}>Unwrap</button> your <strong>$MMFA</strong> for BPT.</p>
		       	<h2>Liquidity Providing</h2>
		       	<p>If you plan on providing liquidity, do so at your own risk. This token has an underlying value. If you are unsure how to calculate it, do not create a liquidity pool.</p>
		       	<p>Follow <a href="https://x.com/inonsonic" target="_blank">@InOnSonic</a> on X for updates though none are promised.</p>
		       	</div>
	       	</div>
	        <div className="dd"><img src={dd}/></div>
	  		
	        <div className="connect-button">
	  			<div className="inliner"><ConnectButton /></div>
	  		</div>

	        <div className={"pending pending--" + pending}>
	  			<p className="pending-title">Transaction Pending</p>
	  			<p className="pending-text">{pendingText}</p>
	  			
	  		</div>
         
      	</div>

	  	
	 
  	</div>
  	)
};